import { useEffect, useState } from "react";

const ConfirmModal = ({
  open,
  title = "Factory Reset Confirmation?",
  message = "Are you sure you want to proceed?",
  count,
  subMessage = "",
  confirmText = "Yes, proceed",
  cancelText = "Cancel",
  danger = true,
  onConfirm,
  onClose,
}) => {
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && !submitting) onClose?.();
      if (e.key === "Enter" && !submitting) handleConfirm();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onConfirm, submitting]);

  const handleConfirm = async () => {
    if (submitting) return;
    try {
      setSubmitting(true);
      const maybePromise = onConfirm?.();
      if (maybePromise && typeof maybePromise.then === "function") {
        await maybePromise;
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) {
    return null;
  }

  return (
    <div
      className="tw-fixed tw-inset-0 tw-z-[100] tw-flex tw-items-center tw-justify-center tw-bg-black/40"
      onClick={(e) => {
        if (e.target === e.currentTarget && !submitting) onClose?.();
      }}
    >
      <div className="tw-bg-white tw-w-[560px] tw-max-w-[94vw] tw-rounded-2xl tw-shadow-xl tw-overflow-hidden">
        <div className="tw-px-6 tw-pt-6 tw-pb-4">
          <h3 className="tw-text-xl tw-font-semibold tw-text-gray-900">
            {title}
          </h3>
        </div>

        <div className="tw-h-px tw-bg-gray-100" />

        <div className="tw-px-6 tw-py-5">
          {message && (
            <p className="tw-text-gray-700 tw-leading-6">{message}</p>
          )}

          {subMessage && (
            <p className="tw-mt-3 tw-text-gray-600 tw-whitespace-pre-line">
              {subMessage}
            </p>
          )}

          {typeof count === "number" && (
            <p className="tw-mt-4 tw-text-gray-900 tw-font-medium">
              Total device selected:&nbsp;
              <span className="tw-font-semibold">{`${count}`}</span>
            </p>
          )}
        </div>

        <div className="tw-h-px tw-bg-gray-100" />
        <div className="tw-px-6 tw-py-5 tw-flex tw-gap-3 tw-justify-center tw-items-center">
          <button
            className={`tw-rounded-xl tw-px-5 tw-py-2.5 tw-font-medium tw-w-[50%] ${
              danger
                ? "tw-border-red-500 tw-border tw-text-red-600 hover:tw-bg-red-50"
                : "tw-border-gray-300 tw-text-gray-800 hover:tw-bg-gray-50"
            } ${submitting ? "tw-opacity-60 tw-cursor-not-allowed" : ""}`}
            onClick={() => !submitting && onClose?.()}
            disabled={submitting}
          >
            {cancelText}
          </button>
          <button
            className={`tw-rounded-xl tw-px-5 tw-py-2.5 tw-border tw-font-medium tw-w-[50%] ${
              danger
                ? "tw-bg-red-600 tw-text-white hover:tw-bg-red-700"
                : "tw-bg-gray-900 tw-text-white hover:tw-bg-black"
            } ${submitting ? "tw-opacity-60 tw-cursor-not-allowed" : ""}`}
            onClick={handleConfirm}
            disabled={submitting}
          >
            <span className="tw-inline-flex tw-items-center">
              {submitting && (
                <svg
                  className="tw-animate-spin tw-h-4 tw-w-4 tw-mr-2"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="tw-opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  />
                  <path
                    className="tw-opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
              )}
              {confirmText}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
